import styled from "styled-components";

const H1 = styled.h1`
  font-size: 40px;
  text-align: center;
`;

export default function NoData() {
  return <H1>- No Data -</H1>;
}
